export default "__VITE_ASSET__9Y4Widt6__"